<div class="quiz-display" (click)="onQuizClick()">
  <div class="result-icon" *ngIf="showIcon">
    <mat-icon>quiz</mat-icon>
  </div>
  <div class="result-content">
    <div class="result-header">
      <span class="quiz-title" [innerHTML]="result.label"></span>
    </div>
    <div class="result-meta">
      <span *ngIf="result.info?.owner">by {{ result.info.owner }}</span>
      <span *ngIf="result.info?.description"> • {{ result.info.description }}</span>
    </div>
  </div>
</div>
